import { getOriginatingTicketId, getSplitTicketId, getSplitTicketTimestamp } from 'conversations-message-history/helpdesk-ticket-split-update-message/operators/getters';
import { useTicketName } from 'svh-tickets-lib/tickets/public/hooks';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import SystemMessage from '../system-message/SystemMessage';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { WorkflowsIcon } from 'foundations-assets';
import { TicketNameLink } from './TicketNameLink';
import { jsx as _jsx } from "react/jsx-runtime";
const HelpdeskTicketSplitUpdateSystemMessage = ({
  message,
  currentTicketId,
  userHasHelpdeskAccess,
  portalId
}) => {
  const originatingTicketId = getOriginatingTicketId(message);
  const splitTicketId = getSplitTicketId(message);
  const timestamp = getSplitTicketTimestamp(message);
  const {
    ticketName: originalTicketName,
    loading: loadingOriginalTicketName
  } = useTicketName(originatingTicketId);
  const {
    ticketName: splitTicketName,
    loading: loadingSplitTicketName
  } = useTicketName(splitTicketId);
  if (currentTicketId === splitTicketId) {
    const messageText = loadingOriginalTicketName ? /*#__PURE__*/_jsx(SkeletonText, {
      inlineSize: "200px"
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.helpdesk-ticket-split-update-message-v2.split-ticket',
      options: {
        originalTicketName: /*#__PURE__*/_jsx(TicketNameLink, {
          ticketId: originatingTicketId,
          ticketName: originalTicketName,
          portalId: portalId,
          userHasHelpdeskAccess: userHasHelpdeskAccess
        })
      }
    });
    return /*#__PURE__*/_jsx(SystemMessage, {
      timestamp: timestamp || undefined,
      description: messageText,
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: "0",
        icon: WorkflowsIcon,
        size: "500"
      })
    });
  }
  if (currentTicketId === originatingTicketId) {
    const messageText = loadingSplitTicketName ? /*#__PURE__*/_jsx(SkeletonText, {
      inlineSize: "200px"
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.helpdesk-ticket-split-update-message-v2.original-ticket',
      options: {
        splitTicketName: /*#__PURE__*/_jsx(TicketNameLink, {
          ticketId: splitTicketId,
          ticketName: splitTicketName,
          portalId: portalId,
          userHasHelpdeskAccess: userHasHelpdeskAccess
        })
      }
    });
    return /*#__PURE__*/_jsx(SystemMessage, {
      timestamp: timestamp || undefined,
      description: messageText,
      icon: /*#__PURE__*/_jsx(IconCircle, {
        borderWidth: "0",
        icon: WorkflowsIcon,
        size: "500"
      })
    });
  }
  const messageText = loadingOriginalTicketName || loadingSplitTicketName ? /*#__PURE__*/_jsx(SkeletonText, {
    inlineSize: "200px"
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: 'conversations-inbox-message-history.helpdesk-ticket-split-update-message-v2.inbox',
    options: {
      splitTicketName: /*#__PURE__*/_jsx(TicketNameLink, {
        ticketId: splitTicketId,
        ticketName: splitTicketName,
        portalId: portalId,
        userHasHelpdeskAccess: userHasHelpdeskAccess
      }),
      originalTicketName: /*#__PURE__*/_jsx(TicketNameLink, {
        ticketId: originatingTicketId,
        ticketName: originalTicketName,
        portalId: portalId,
        userHasHelpdeskAccess: userHasHelpdeskAccess
      })
    }
  });
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: timestamp || undefined,
    description: messageText,
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: WorkflowsIcon,
      size: "500"
    })
  });
};
HelpdeskTicketSplitUpdateSystemMessage.displayName = 'HelpdeskTicketSplitUpdateSystemMessage';
export default HelpdeskTicketSplitUpdateSystemMessage;